const routes = {
  bucketsPath: '/buckets',
  bucketPath: '/bucket',
  communitiesPath: '/files/communities',
  filesDetailsPath: '/files/details',
  filesDownloadPath: '/files/download',
  filesPath: '/files',
  folderPermissions: '/files/manage',
  itemEditPath: '/ItemEdit',
  itemPath: '/item',
  userPath: '/items/user',
  servicesPath: '/services',
  metadataPath: '/view',
  downloadFile: '/download',
}

export default routes

